import React, { PureComponent } from 'react'
import cx from 'classnames'
import { func, string, bool, } from 'prop-types'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router'
import { FormattedMessage } from 'react-intl'

import Layout from 'src/components/Layout/Layout/index'
import injectLanguage from 'src/components/LanguageWrapper/inject'
import SvgIcon from 'src/components/SvgIcon'
import { Left, Body, Right } from 'src/components/Layout/Header'
import HeaderDropdown from 'src/components/Layout/Header/Dropdown'
import { WidgetContext } from 'src/modules/App/WidgetContext'
import { logError, storeDocumentTitle, updateDocumentTitle } from 'src/utils/helpers'
import Storage from 'src/utils/storage'

import styles from "../header.module.less"

const { Header } = Layout

class HeaderContainer extends PureComponent {
  static propTypes = {
    rightRender: func,
    showBack: bool,
    showRight: bool,
    title: string
  }

  static defaultProps = {
    showBack: true,
    showRight: true,
    rightRender: null,
    title: null,
    additionalRightActions: function () {}
  }

  componentDidMount() {
    try {
      // Only if widget and title is not already update with temporary/flashing title
      if (this.props.isWidget && Storage.getItem('hasFlashingDocumentTitle') !== '1') {
        // Save current document title
        storeDocumentTitle()
      }
    } catch (e) {
      logError('Update document title', e)
    }
  }

  onBack = () => {
    const { onBack, history } = this.props

    if (typeof onBack === 'function') {
      onBack()
    } else {
      history.goBack()
    }
  }

  renderRight = () => {
    const { showRight, rightRender, renderRightAddition } = this.props

    if (typeof rightRender === 'function') {
      return rightRender()
    } else {
      return (
        <div
          display-if={showRight}
          style={{ textAlign: "right" }}
        >
          <HeaderDropdown refKey="dropdown-header-combined" hideOnDesktop={true} />

          {typeof renderRightAddition === 'function' ? (
            renderRightAddition()
          ) : ''}
        </div>
      )
    }
  }

  /**
   * Returns custom document title based on current header title.
   *
   * Also updates it to storage to be ready for flashing/changing (e.g. for new chat messages).
   *
   * @return {string} New document title
   */
  handleDocumentTitle = () => {
    const {
      title,
      brand,
      useDefaultDocumentTitle,
    } = this.props

    const documentTitle = useDefaultDocumentTitle || !title ? brand.name : title

    updateDocumentTitle(documentTitle)

    return documentTitle
  }

  render() {
    const {
      showBack,
      isWidget,
      title,
      brand,
      hideBackText,
      hideOnDesktop,
      hideBackOnDesktop,
      bodyReplace,
      className,
      classNameLeft,
      classNameBody,
      classNameRight,
    } = this.props

    const classNames = cx({
      [styles.header]: true,
      [styles.headerHideOnDesktop]: hideOnDesktop === true,
      [className]: !!className,
    })

    const classNamesLeft = cx({
      [classNameLeft]: !!classNameLeft,
    })

    const classNamesBody = cx({
      [classNameBody]: !!classNameBody,
    })

    const classNamesRight = cx({
      [classNameRight]: !!classNameRight,
    })

    const classNamesLeftIcon = cx({
      [styles.leftIcon]: true,
      [styles.leftIconHideOnDesktop]: hideBackOnDesktop === true,
    })

    return (
       <Header className={classNames}>
        { !isWidget && <Helmet title={this.handleDocumentTitle()} /> }
        <Left className={classNamesLeft}>
          <span display-if={showBack} onClick={this.onBack} className={classNamesLeftIcon}>
            <SvgIcon size={'xs'} type="BackArrow" className={styles.backIcon} />
            <span display-if={!hideBackText} className={styles.backText}>
              <FormattedMessage
                id="app.header.back"
                defaultMessage="back"
              />
            </span>
          </span>
        </Left>
        {typeof bodyReplace === 'function' ? (
          bodyReplace()
        ) : (
          <Body data-cy="headerTitle" className={classNamesBody}>{title || brand.name}</Body>
        )}
        <Right className={classNamesRight}>
          { this.renderRight() }
        </Right>
      </Header>
    )
  }
}

const HeaderContainerContext = (props) => (
  <WidgetContext.Consumer>
    {context => <HeaderContainer { ...props } { ...context } />}
  </WidgetContext.Consumer>
);

const HeaderContainerContextWithLanguage = injectLanguage(HeaderContainerContext)


export default withRouter(HeaderContainerContextWithLanguage)
